// extracted by mini-css-extract-plugin
export default {"programDetailsDisclaimer":"styles_programDetailsDisclaimer__xU4Xf","disclaimer":"styles_disclaimer__gmsIt"};